export const EVO_REGIONS = ['UK', 'EU', 'US', 'APAC'];

export const normalizeEvoRegion = (region?: string | null): string | null => {
  if (!region) return null;
  const normalized = region.trim().toUpperCase();
  return EVO_REGIONS.includes(normalized) ? normalized : null;
};
